<script module lang="ts">
	export type FormState = null | 'processing' | 'success' | 'error';
</script>

<script lang="ts">
	import { checkVisibility } from '$lib/actions/checkVisibility';
	import Button from '$lib/buttons/v3/button.svelte';
	import type { FullAutoFill } from 'svelte/elements';

	interface Props {
		name: string;
		placeholder: string;
		withSubmitButton?: boolean;
		autofocus?: boolean;
		autocomplete?: FullAutoFill | null;
		formState?: FormState;
	}

	let {
		name,
		placeholder,
		withSubmitButton = false,
		autofocus = false,
		autocomplete = null,
		formState = $bindable(null)
	}: Props = $props();

	let isFocused = $state(false);
	let input = $state('');
	let inputField: HTMLInputElement | undefined = $state(undefined);
	let btnWidth: undefined | number = $state(undefined);

	function focus() {
		inputField?.focus();
	}
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
	class={[
		'relative cursor-text rounded-2xl border bg-brown-6 pl-5',
		isFocused ? 'border-brown-1' : 'border-brown-5'
	]}
	onclick={focus}
	style="padding-right: {(btnWidth || 8) + 12}px;"
>
	<input
		bind:this={inputField}
		class="relative z-10 mb-2 mt-[26px] flex w-full flex-col justify-center bg-transparent text-[16px] tracking-[-.16px] focus:outline-none"
		type="text"
		{autocomplete}
		{name}
		bind:value={input}
		onfocusin={() => (isFocused = true)}
		onfocusout={() => (isFocused = false)}
		use:checkVisibility
		onvisible={(e) => {
			if (e.detail && autofocus) {
				focus();
			}
		}}
	/>
	<p
		class={[
			'absolute inset-y-0 left-5 z-0 flex flex-col justify-center  text-brown-4 transition-all',
			(isFocused || input.length > 0) && '-translate-y-3 text-[12px]',
			!isFocused && input.length === 0 && 'text-[16px] tracking-[-.16px]'
		]}
	>
		{placeholder}
	</p>

	{#if withSubmitButton}
		<div
			bind:clientWidth={btnWidth}
			class="absolute inset-y-0 right-2 z-30 flex flex-col justify-center"
		>
			<Button
				disabled={formState === 'processing'}
				type="submit"
				class={['btn-small', formState === 'processing' ? 'opacity-30' : '']}>Submit</Button
			>
		</div>
	{/if}
</div>
